<template>
    <div class="card" style="direction:rtl">
        <div class="card-header">
            <h3 class="card-title">نقش ها</h3>
            <CButton @click="DialogAddRole = true" color="primary" style="float:left">افزودن</CButton>
        </div>
        <div class="card-body" style="direction: rtl">
            <CDataTable
                :hover="true"
                :border="true"
                
                :striped="true"
                :small="true"
                :items="$store.state.Rules_GetAll.RequestResponse"
                :fields="fields"
                :fixed="true"
                :clickableRows="true"
                :items-per-page="7"
                pagination
                style="overflow: hidden;margin-top:10px"
                >
                <template #Rows="{index}">
                    <td style="direction: ltr">
                        {{index+1 }}
                    </td>
                </template>
                <template #View="{item}">
                    <td style="direction: ltr">
                        <CButton v-if="(item.Name_EN!=='Admin' && Permission.RulesID!==item.RulesID) || (Permission.RulesID===1)"  color="primary"  @click="View(item)">
                                    ویرایش دسترسی
                        </CButton>
                        <CButton v-else color="primary"  disabled>
                                    ویرایش دسترسی
                        </CButton>
                    </td>
                </template>
                <template #API="{item}">
                    <td style="direction: ltr">
                        <CButton v-if="(item.Name_EN!=='Admin' && Permission.RulesID!==item.RulesID)|| (Permission.RulesID===1)" color="primary"  @click="ViewApi(item)">
                                    ویرایش دسترسی
                        </CButton>
                        <CButton v-else color="primary"  disabled>
                                    ویرایش دسترسی
                        </CButton>
                    </td>
                </template>



            </CDataTable>
        </div>
         <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'lg'"
                :show.sync="DialogAddRole"
        >
            <div style="direction: rtl;text-align: right">
                <CRow>
                    <CCol>
                        <CInput
                            label="نام نقش فارسی"
                            valid-feedback=""
                            invalid-feedback="حداقل چهار  کارکتر  می باشد."
                            value="Valid value"
                            v-model="role.RoleName"
                            
                        />
                    </CCol>
                    <CCol>
                        <CInput
                            label="نام نقش لاتین"
                            valid-feedback=""
                            invalid-feedback=""
                            value="Valid value"
                            v-model="role.RoleName_EN"
                            
                        />
                    </CCol>
                    
                </CRow>
            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp;افزودن نقش</h4>

            </template>
            <template #footer>
                <CButton @click="DialogAddRole = false" color="warning">انصراف</CButton>
                <CButton color="primary" @click="Rules_Insert()">&nbsp;&nbsp;  افزودن نقش</CButton>
            </template>
        </CModal>
    </div>
</template>

<script>
    export default {
        name: "Pages",
        data(){
            return{
                fields:[{key:'Rows',label:'ردیف'},{key:'Name_EN',label:'نام نقش لاتین'},{key:'Name',label:'نام فارسی نقش'},{key:'View',label:'دسترسی صفحات'},{key:'API',label:'دسترسی سرویس ها'}],
                DialogAddRole:false,
                role:{
                    RoleName:"",
                    RoleName_EN:""
                },
                User:{},
                Permission:{},
            }
        },
        computed:{
            ReadRules_Insert(){
                return this.$store.state.Rules_Insert;
            }
        },
        watch:{
            ReadRules_Insert(res){
                if(res.Status){
                    if(res.RequestResponse[0].Message==='Successfully!'){
                        this.DialogAddRole=false;
                        this.$store.commit('ShowToast',{type:'success',message:'عملیات با موفقیت انجام شد.'})
                    }
                    
                }
            }
        },
        mounted(){
            this.Permission=this.$session.get("Permission");
            this.Rules_GetAll();
        },
        methods:{
            Rules_GetAll(id){
                this.$store.commit('Rules_GetAll',{
                    Rules_ID:id
                });
            },
            Rules_Insert(){
                if(this.role.RoleName==='' || this.role.RoleName_EN===''){
                    this.$store.commit('ShowToast',{type:'error',message:'تمامی فیلد ها اجباری هستند'});
                    return;
                }
                this.$store.commit('Rules_Insert',{
                    RoleName:this.role.RoleName,
                    RoleName_EN:this.role.RoleName_EN,
                });
            },
            View(item){
                window.open('/#/security/roles/role?RoleID='+item.RulesID,'_self')
            },
            ViewApi(item){
                window.open('/#/security/roles/api?RoleID='+item.RulesID,'_self')
            }
        }
    }
</script>

<style scoped>

</style>